function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function findNode(fullPath, currentNode, nodeToFind) {
  if (nodeToFind === currentNode) {
    return fullPath;
  }
  var fragment = currentNode.content;
  if (!fragment || !fragment.content) return null;
  var res = fragment.content.map(function (currentNode, i) {
    return findNode([].concat(_toConsumableArray(fullPath), ["content", i]), currentNode, nodeToFind);
  }).filter(function (res) {
    return Array.isArray(res) && res.length;
  })[0];
  return res;
}
export default function findNodeIn(doc, node) {
  var path = findNode([], doc, node);
  if (path) {
    return path.reduce(function (newPath, item) {
      // [0, content, content, 0] => [0, content, 0]
      // Because JSON representation a bit different from actual DOC.
      if (item === "content" && newPath[newPath.length - 1] === "content") {
        return newPath;
      }
      newPath.push(item);
      return newPath;
    }, []);
  }
}
export function findNodeJSON(fullPath, currentNode, nodeToFind) {
  if (nodeToFind === currentNode) {
    return fullPath;
  }
  if (!currentNode.content) return [];
  if (currentNode.content === nodeToFind) {
    return fullPath.concat("content");
  }
  var res = currentNode.content.map(function (currentNode, i) {
    return findNodeJSON([].concat(_toConsumableArray(fullPath), ["content", i]), currentNode, nodeToFind);
  }).filter(function (res) {
    return Array.isArray(res) && res.length;
  })[0];
  return res;
}
export function findPMNode(domNode) {
  var node;
  var target = domNode;
  while (!node && target) {
    if (target.pmViewDesc) {
      node = target;
    }
    target = target.parentNode;
  }
  return node;
}